
// (function () {
//   if (document.cookie.indexOf('otp_verified=true') !== -1) return;

//   document.body.style.display = 'none';

//   const style = document.createElement('style');
//   style.innerHTML = `
   

//     #otp-overlay {
//       position: fixed;
//       top: 0; left: 0;
//       width: 100%; height: 100%;
//       z-index: 99999;
//       display: flex;
//       align-items: flex-start;
//       justify-content: center;
//       font-family: sans-serif;
//       overflow-y: auto;
//       padding: 20px 0;
//     }
//     #otp-overlay::before {
//       content: '';
//       position: fixed;
//       top: 0; left: 0;
//       width: 100%; height: 100%;
//       background-image: url('https://cdn.shopify.com/s/files/1/0975/0600/1212/files/WhatsApp_Image_2026-06-10_at_1.51.05_PM.jpg?v=1781124743');
//       background-size: cover;
//       background-position: center;
//       background-repeat: no-repeat;
//       background-color: rgba(0,0,0,0.6);
//       background-blend-mode: darken;
//       z-index: -1;
//     }

  
//     #otp-box {
//       background: #fff;
//       border: 1px solid #ddd;
//       border-radius: 12px;
//       padding: 20px;
//       width:70%;
//       max-width: 500px;
//       margin: 140px auto;
//       box-sizing: border-box;
//       animation: zoomInUp 0.9s cubic-bezier(0.165, 0.84, 0.44, 1);
//     }
//     @keyframes zoomInUp {
//       0% {
//         transform: translateY(80px) scale(0.8);
//         opacity: 0;
//       }
//       60% {
//         transform: translateY(-8px) scale(1.02);
//         opacity: 1;
//       }
//       100% {
//         transform: translateY(0) scale(1);
//         opacity: 1;
//       }
//     }
//     #otp-box h2 {
//       margin-bottom: 4px;
//       font-size: 28px;
//       color: #111;
//       text-align: center;
//       font-weight: 700 !important;
//     }
//     .subtitle {
//       color: #666;
//       font-size: 13px;
//       margin-bottom: 20px;
//       text-align: center;
//     }
//     .form-row {
//       display: flex;
//       gap: 10px;
//       margin-bottom: 10px;
//     }
//     .form-group {
//       display: flex;
//       flex-direction: column;
//       flex: 1;
//       margin-bottom: 10px;
//     }
//     .form-group label {
//       font-size: 15px;
//       color: #111 !important;
//       margin-bottom: 3px;
//       font-weight: 700 !important;
//       background: #f8f8f8;
//       padding: 2px 6px;
//       border-radius: 4px;
//     }
//     .form-group input,
//     .form-group select {
//       padding: 8px 10px;
//       border: 1px solid #ddd;
//       border-radius: 6px;
//       font-size: 13px;
//       box-sizing: border-box;
//       width: 100%;
//     }
//     .form-group input:focus,
//     .form-group select:focus {
//       outline: none;
//       border-color: #111;
//     }
//     .required { color: red; }
//     .section-title {
//       font-size: 24px !important;
//       font-weight: 700 !important;
//       font-style: italic !important;
//       color: #af4a4aff !important;
//       letter-spacing: 0.3px;
//       margin: 8px 0 4px;
//       border-bottom: 1px solid #eee;
//       padding-bottom: 2px;
//       text-transform: none !important;
//     }
//     button.primary {
//       width: 100%;
//       padding: 11px;
//       background: #111;
//       color: #fff;
//       border: none;
//       border-radius: 8px;
//       font-size: 14px;
//       cursor: pointer;
//       margin-top: 10px;
//     }
//     button.primary:hover { background: #333; }
//     button.secondary {
//       width: 100%;
//       padding: 11px;
//       background: #fff;
//       color: #111;
//       border: 1px solid #ddd;
//       border-radius: 8px;
//       font-size: 14px;
//       cursor: pointer;
//       margin-top: 8px;
//     }
//     #otp-msg, #otp-msg2 {
//       font-size: 12px;
//       margin-top: 6px;
//       min-height: 18px;
//       text-align: center;
//     }
//     .error { color: red; }
//     .success { color: green; }

//     // @media (max-width: 768px) {
//     //   #otp-box {
//     //     width: 88%;
//     //     max-width: 88%;
//     //     margin: 15px auto;
//     //     padding: 14px;
//     //     border-radius: 10px;
//     //   }
//     @media (max-width: 768px) {
//       #otp-overlay {
//         background-attachment: scroll !important;
//         background-size: cover !important;
//         background-position: center !important;
//         align-items: flex-start !important;
//         padding: 15px 0 30px !important;
//       }
//       #otp-box {
//         width: 75% !important;
//         max-width: 75% !important;
//         margin: 10px auto !important;
//         padding: 12px !important;
//         border-radius: 10px !important;
//         font-size: 12px !important;
//       }
//       #otp-box h2 {
//         font-size: 18px !important;
//       }
//       .section-title {
//         font-size: 14px !important;
//       }
//       .form-group label {
//         font-size: 11px !important;
//       }
//       .form-group input,
//       .form-group select {
//         font-size: 12px !important;
//         padding: 7px 8px !important;
//       }
//       .form-row {
//         flex-direction: column !important;
//         gap: 0 !important;
//       }
//       button.primary, button.secondary {
//         padding: 11px !important;
//         font-size: 13px !important;
//       }
//     }
//       #otp-box h2 {
//         font-size: 20px !important;
//       }
//       .section-title {
//         font-size: 16px !important;
//       }
//       .form-group label {
//         font-size: 12px !important;
//       }
//       .form-group input,
//       .form-group select {
//         font-size: 14px;
//         padding: 10px 8px;
//       }
//       .form-row {
//         flex-direction: column;
//         gap: 0;
//       }
//       button.primary, button.secondary {
//         padding: 13px;
//         font-size: 15px;
//       }
//     }
//   `;
//   document.head.appendChild(style);

//   const overlay = document.createElement('div');
//   overlay.id = 'otp-overlay';

//   const bg = document.createElement('div');
//   bg.id = 'otp-overlay-bg';
//   overlay.appendChild(bg);

//   const box = document.createElement('div');
//   box.id = 'otp-box';
//   box.innerHTML = `
//       <h2>Welcome to Lara Leather</h2>
//       <p class="subtitle">Please register to access our wholesale store</p>

//       <div id="step-register">
//         <div class="section-title">Business Information</div>

//         <div class="form-group">
//           <label>Company Name <span class="required">*</span></label>
//           <input type="text" id="inp-company" placeholder="Your company name" />
//         </div>

//         <div class="form-row">
//           <div class="form-group">
//             <label>First Name <span class="required">*</span></label>
//             <input type="text" id="inp-firstname" placeholder="First name" />
//           </div>
//           <div class="form-group">
//             <label>Last Name <span class="required">*</span></label>
//             <input type="text" id="inp-lastname" placeholder="Last name" />
//           </div>
//         </div>

//         <div class="form-group">
//           <label>Email Address <span class="required">*</span></label>
//           <input type="email" id="inp-email" placeholder="your@email.com" />
//         </div>

//         <div class="form-group">
//           <label>Phone Number <span class="required">*</span></label>
//           <input type="tel" id="inp-phone" placeholder="+1 234 567 8900" />
//         </div>

//         <div class="section-title">Business Details</div>

//         <div class="form-group">
//           <label>Website</label>
//           <input type="text" id="inp-website" placeholder="www.yourwebsite.com" />
//         </div>

//         <div class="section-title">Address</div>

//         <div class="form-group">
//           <label>Address Line 1 <span class="required">*</span></label>
//           <input type="text" id="inp-address1" placeholder="Street address" />
//         </div>

//         <div class="form-group">
//           <label>Address Line 2</label>
//           <input type="text" id="inp-address2" placeholder="Apt, suite, unit, etc." />
//         </div>

//         <div class="form-row">
//           <div class="form-group">
//             <label>City <span class="required">*</span></label>
//             <input type="text" id="inp-city" placeholder="City" />
//           </div>
//           <div class="form-group">
//             <label>ZIP Code</label>
//             <input type="text" id="inp-zip" placeholder="ZIP code" />
//           </div>
//         </div>

//         <div class="form-group">
//           <label>Country <span class="required">*</span></label>
//           <select id="inp-country">
//             <option value="">Select a country</option>
//             <option>United States</option>
//             <option>United Kingdom</option>
//             <option>Canada</option>
//             <option>Australia</option>
//             <option>Pakistan</option>
//             <option>UAE</option>
//             <option>Germany</option>
//             <option>France</option>
//             <option>Italy</option>
//             <option>Spain</option>
//             <option>Netherlands</option>
//             <option>Other</option>
//           </select>
//         </div>

//         <button class="primary" onclick="otpSendCode()">Submit Application</button>
//         <div id="otp-msg"></div>
//       </div>

//       // <div id="step-verify" style="display:none;">
//       //   <p id="verify-msg" style="text-align:center;color:#444;font-size:13px;">Enter the 6-digit code sent to your email</p>
//       //   <div class="form-group">
//       //     <label>Verification Code <span class="required">*</span></label>
//       //     <input type="text" id="inp-otp" placeholder="000000" maxlength="6" style="font-size:22px;letter-spacing:10px;text-align:center;" />
//       //   </div>
//       //   <button class="primary" onclick="otpVerify()">Verify & Enter Store</button>
//       //   <button class="secondary" onclick="otpResend()">Resend Code</button>
//       //   <div id="otp-msg2"></div>
//       // </div>
//   `;

//   overlay.appendChild(box);
//   document.body.appendChild(overlay);
//   document.body.style.display = 'block';

//   let currentEmail = '';

//   window.otpSendCode = async function () {
//     const company = document.getElementById('inp-company').value.trim();
//     const firstname = document.getElementById('inp-firstname').value.trim();
//     const lastname = document.getElementById('inp-lastname').value.trim();
//     const email = document.getElementById('inp-email').value.trim();
//     const phone = document.getElementById('inp-phone').value.trim();
//     const website = document.getElementById('inp-website').value.trim();
//     const address1 = document.getElementById('inp-address1').value.trim();
//     const address2 = document.getElementById('inp-address2').value.trim();
//     const city = document.getElementById('inp-city').value.trim();
//     const zip = document.getElementById('inp-zip').value.trim();
//     const country = document.getElementById('inp-country').value;
//     const msg = document.getElementById('otp-msg');

//     if (!company) { msg.className = 'error'; msg.textContent = 'Please enter company name.'; return; }
//     if (!firstname) { msg.className = 'error'; msg.textContent = 'Please enter first name.'; return; }
//     if (!lastname) { msg.className = 'error'; msg.textContent = 'Please enter last name.'; return; }
//     if (!email) { msg.className = 'error'; msg.textContent = 'Please enter email address.'; return; }
//     if (!phone) { msg.className = 'error'; msg.textContent = 'Please enter phone number.'; return; }
//     if (!address1) { msg.className = 'error'; msg.textContent = 'Please enter address.'; return; }
//     if (!city) { msg.className = 'error'; msg.textContent = 'Please enter city.'; return; }
//     if (!country) { msg.className = 'error'; msg.textContent = 'Please select country.'; return; }

//     msg.className = ''; msg.textContent = 'Sending verification code...';

//     try {
//       const res = await fetch('https://lara-otp.vercel.app/api/register', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ company, firstname, lastname, email, phone, website, address1, address2, city, zip, country })
//       });
//       const data = await res.json();
//       if (data.success) {
//         currentEmail = email;
//         document.getElementById('otp-box').innerHTML = `
//           <div style="text-align:center;padding:40px 20px;">
//             <h2 style="color:#111;">⏳ Application Submitted!</h2>
//             <p style="color:#666;font-size:14px;">Thank you! Please wait while we review your application...</p>
//             <div id="status-msg" style="margin-top:16px;font-size:13px;color:#888;">Checking approval status...</div>
//           </div>
//         `;
//         checkApproval(email);
//       } else {
//         msg.className = 'error'; msg.textContent = data.error || 'Something went wrong.';
//       }
//     } catch (e) {
//       msg.className = 'error'; msg.textContent = 'Server error. Try again.';
//     }
//   };

//   window.otpVerify = async function () {
//     const otp = document.getElementById('inp-otp').value.trim();
//     const msg = document.getElementById('otp-msg2');

//     if (!otp) { msg.className = 'error'; msg.textContent = 'Please enter verification code.'; return; }

//     msg.className = ''; msg.textContent = 'Verifying...';

//     try {
//       const res = await fetch('https://lara-otp.vercel.app/api/verify', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email: currentEmail, otp })
//       });
//       const data = await res.json();
//       if (data.success) {
//         document.cookie = 'otp_verified=true; max-age=2592000; path=/';
//         document.getElementById('otp-overlay').remove();
//         window.location.href = 'https://laraleatherwholesale.com/';
//       } else {
//         msg.className = 'error'; msg.textContent = data.error || 'Invalid code.';
//       }
//     } catch (e) {
//       msg.className = 'error'; msg.textContent = 'Server error. Try again.';
//     }
//   };

//   window.otpResend = function () {
//     document.getElementById('step-verify').style.display = 'none';
//     document.getElementById('step-register').style.display = 'block';
//   };
//   async function checkApproval(email) {
//     const interval = setInterval(async () => {
//       try {
//         const res = await fetch('https://lara-otp.vercel.app/api/check?email=' + encodeURIComponent(email));
//         const data = await res.json();
//         if (data.approved) {
//           clearInterval(interval);
//           document.cookie = 'otp_verified=true; max-age=2592000; path=/';
//           window.location.href = 'https://laraleatherwholesale.com/';
//         } else if (data.rejected) {
//           clearInterval(interval);
//           document.getElementById('otp-box').innerHTML = `
//             <div style="text-align:center;padding:40px 20px;">
//               <h2 style="color:red;">❌ Application Rejected</h2>
//               <p style="color:#666;font-size:14px;">Unfortunately your application has not been approved at this time.<br>Please contact us for more information.</p>
//             </div>
//           `;
//         } else {
//           document.getElementById('status-msg').textContent = 'Still waiting for approval...';
//         }
//       } catch(e) {}
//     }, 5000);
//   }
// })();



// // (function () {
// //   if (document.cookie.indexOf('otp_verified=true') !== -1) return;

// //   document.body.style.display = 'none';

// //   const isMobile = window.innerWidth <= 768;

// //   const style = document.createElement('style');
// //   style.innerHTML = `
// //     #otp-overlay {
// //       position: fixed;
// //       top: 0; left: 0;
// //       width: 100%; height: 100%;
// //       z-index: 99999;
// //       display: flex;
// //       align-items: flex-start;
// //       justify-content: center;
// //       font-family: sans-serif;
// //       overflow-y: auto;
// //       padding: 20px 0;
// //     }
// //     #otp-bg {
// //       position: fixed;
// //       top: 0; left: 0;
// //       width: 100%;
// //       height: 100%;
// //       background-image: url('https://cdn.shopify.com/s/files/1/0975/0600/1212/files/WhatsApp_Image_2026-06-10_at_1.51.05_PM.jpg?v=1781124743');
// //       background-size: cover;
// //       background-position: center;
// //       background-repeat: no-repeat;
// //       z-index: 0;
// //     }
// //     #otp-bg-overlay {
// //       position: fixed;
// //       top: 0; left: 0;
// //       width: 100%;
// //       height: 100%;
// //       background: rgba(0,0,0,0.55);
// //       z-index: 1;
// //     }
// //     #otp-box {
// //       position: relative;
// //       z-index: 2;
// //       background: #fff;
// //       border: 1px solid #ddd;
// //       border-radius: 12px;
// //       padding: 20px;
// //       width: 90%;
// //       max-width: 500px;
// //       margin: 20px auto;
// //       box-sizing: border-box;
// //       animation: zoomInUp 0.9s cubic-bezier(0.165, 0.84, 0.44, 1);
// //     }
// //     @keyframes zoomInUp {
// //       0% { transform: translateY(80px) scale(0.8); opacity: 0; }
// //       60% { transform: translateY(-8px) scale(1.02); opacity: 1; }
// //       100% { transform: translateY(0) scale(1); opacity: 1; }
// //     }
// //     #otp-box h2 {
// //       margin-bottom: 4px;
// //       font-size: 28px;
// //       color: #111;
// //       text-align: center;
// //       font-weight: 700 !important;
// //     }
// //     .subtitle {
// //       color: #666;
// //       font-size: 13px;
// //       margin-bottom: 20px;
// //       text-align: center;
// //     }
// //     .form-row {
// //       display: flex;
// //       gap: 10px;
// //       margin-bottom: 10px;
// //     }
// //     .form-group {
// //       display: flex;
// //       flex-direction: column;
// //       flex: 1;
// //       margin-bottom: 10px;
// //     }
// //     .form-group label {
// //       font-size: 15px;
// //       color: #111 !important;
// //       margin-bottom: 3px;
// //       font-weight: 700 !important;
// //       background: #f8f8f8;
// //       padding: 2px 6px;
// //       border-radius: 4px;
// //     }
// //     .form-group input,
// //     .form-group select {
// //       padding: 8px 10px;
// //       border: 1px solid #ddd;
// //       border-radius: 6px;
// //       font-size: 13px;
// //       box-sizing: border-box;
// //       width: 100%;
// //     }
// //     .required { color: red; }
// //     .section-title {
// //       font-size: 24px !important;
// //       font-weight: 700 !important;
// //       font-style: italic !important;
// //       color: #af4a4aff !important;
// //       letter-spacing: 0.3px;
// //       margin: 8px 0 4px;
// //       border-bottom: 1px solid #eee;
// //       padding-bottom: 2px;
// //       text-transform: none !important;
// //     }
// //     button.primary {
// //       width: 100%;
// //       padding: 11px;
// //       background: #111;
// //       color: #fff;
// //       border: none;
// //       border-radius: 8px;
// //       font-size: 14px;
// //       cursor: pointer;
// //       margin-top: 10px;
// //     }
// //     button.primary:hover { background: #333; }
// //     button.secondary {
// //       width: 100%;
// //       padding: 11px;
// //       background: #fff;
// //       color: #111;
// //       border: 1px solid #ddd;
// //       border-radius: 8px;
// //       font-size: 14px;
// //       cursor: pointer;
// //       margin-top: 8px;
// //     }
// //     #otp-msg, #otp-msg2 {
// //       font-size: 12px;
// //       margin-top: 6px;
// //       min-height: 18px;
// //       text-align: center;
// //     }
// //     .error { color: red; }
// //     .success { color: green; }
// //   `;
// //   document.head.appendChild(style);

// //   if (isMobile) {
// //     const mobileStyle = document.createElement('style');
// //     mobileStyle.innerHTML = `
// //       #otp-box {
// //         width: 76% !important;
// //         max-width: 76% !important;
// //         margin: 12px auto !important;
// //         padding: 12px !important;
// //       }
// //       #otp-box h2 {
// //         font-size: 18px !important;
// //       }
// //       .section-title {
// //         font-size: 15px !important;
// //       }
// //       .form-group label {
// //         font-size: 11px !important;
// //       }
// //       .form-group input,
// //       .form-group select {
// //         font-size: 12px !important;
// //         padding: 7px 8px !important;
// //       }
// //       .form-row {
// //         flex-direction: column !important;
// //         gap: 0 !important;
// //       }
// //       button.primary, button.secondary {
// //         padding: 11px !important;
// //         font-size: 13px !important;
// //       }
// //     `;
// //     document.head.appendChild(mobileStyle);
// //   }

// //   const overlay = document.createElement('div');
// //   overlay.id = 'otp-overlay';

// //   const bg = document.createElement('div');
// //   bg.id = 'otp-bg';

// //   const bgOverlay = document.createElement('div');
// //   bgOverlay.id = 'otp-bg-overlay';

// //   const box = document.createElement('div');
// //   box.id = 'otp-box';
// //   box.innerHTML = `
// //     <h2>Welcome to Lara Leather</h2>
// //     <p class="subtitle">Please register to access our wholesale store</p>

// //     <div id="step-register">
// //       <div class="section-title">Business Information</div>
// //       <div class="form-group">
// //         <label>Company Name <span class="required">*</span></label>
// //         <input type="text" id="inp-company" placeholder="Your company name" />
// //       </div>
// //       <div class="form-row">
// //         <div class="form-group">
// //           <label>First Name <span class="required">*</span></label>
// //           <input type="text" id="inp-firstname" placeholder="First name" />
// //         </div>
// //         <div class="form-group">
// //           <label>Last Name <span class="required">*</span></label>
// //           <input type="text" id="inp-lastname" placeholder="Last name" />
// //         </div>
// //       </div>
// //       <div class="form-group">
// //         <label>Email Address <span class="required">*</span></label>
// //         <input type="email" id="inp-email" placeholder="your@email.com" />
// //       </div>
// //       <div class="form-group">
// //         <label>Phone Number <span class="required">*</span></label>
// //         <input type="tel" id="inp-phone" placeholder="+1 234 567 8900" />
// //       </div>

// //       <div class="section-title">Business Details</div>
// //       <div class="form-group">
// //         <label>Website</label>
// //         <input type="text" id="inp-website" placeholder="www.yourwebsite.com" />
// //       </div>

// //       <div class="section-title">Address</div>
// //       <div class="form-group">
// //         <label>Address Line 1 <span class="required">*</span></label>
// //         <input type="text" id="inp-address1" placeholder="Street address" />
// //       </div>
// //       <div class="form-group">
// //         <label>Address Line 2</label>
// //         <input type="text" id="inp-address2" placeholder="Apt, suite, unit, etc." />
// //       </div>
// //       <div class="form-row">
// //         <div class="form-group">
// //           <label>City <span class="required">*</span></label>
// //           <input type="text" id="inp-city" placeholder="City" />
// //         </div>
// //         <div class="form-group">
// //           <label>ZIP / Postal Code</label>
// //           <input type="text" id="inp-zip" placeholder="ZIP code" />
// //         </div>
// //       </div>
// //       <div class="form-group">
// //         <label>Country <span class="required">*</span></label>
// //         <select id="inp-country">
// //           <option value="">Select a country</option>
// //           <option>United States</option>
// //           <option>United Kingdom</option>
// //           <option>Canada</option>
// //           <option>Australia</option>
// //           <option>Pakistan</option>
// //           <option>UAE</option>
// //           <option>Germany</option>
// //           <option>France</option>
// //           <option>Italy</option>
// //           <option>Spain</option>
// //           <option>Netherlands</option>
// //           <option>Other</option>
// //         </select>
// //       </div>
// //       <button class="primary" onclick="otpSendCode()">Send Verification Code</button>
// //       <div id="otp-msg"></div>
// //     </div>

// //     <div id="step-verify" style="display:none;">
// //       <p id="verify-msg" style="text-align:center;color:#444;font-size:13px;">Enter the 6-digit code sent to your email</p>
// //       <div class="form-group">
// //         <label>Verification Code <span class="required">*</span></label>
// //         <input type="text" id="inp-otp" placeholder="000000" maxlength="6" style="font-size:22px;letter-spacing:10px;text-align:center;" />
// //       </div>
// //       <button class="primary" onclick="otpVerify()">Verify & Enter Store</button>
// //       <button class="secondary" onclick="otpResend()">Resend Code</button>
// //       <div id="otp-msg2"></div>
// //     </div>
// //   `;

// //   overlay.appendChild(bg);
// //   overlay.appendChild(bgOverlay);
// //   overlay.appendChild(box);
// //   document.body.appendChild(overlay);
// //   document.body.style.display = 'block';

// //   let currentEmail = '';

// //   window.otpSendCode = async function () {
// //     const company = document.getElementById('inp-company').value.trim();
// //     const firstname = document.getElementById('inp-firstname').value.trim();
// //     const lastname = document.getElementById('inp-lastname').value.trim();
// //     const email = document.getElementById('inp-email').value.trim();
// //     const phone = document.getElementById('inp-phone').value.trim();
// //     const website = document.getElementById('inp-website').value.trim();
// //     const address1 = document.getElementById('inp-address1').value.trim();
// //     const address2 = document.getElementById('inp-address2').value.trim();
// //     const city = document.getElementById('inp-city').value.trim();
// //     const zip = document.getElementById('inp-zip').value.trim();
// //     const country = document.getElementById('inp-country').value;
// //     const msg = document.getElementById('otp-msg');

// //     if (!company) { msg.className = 'error'; msg.textContent = 'Please enter company name.'; return; }
// //     if (!firstname) { msg.className = 'error'; msg.textContent = 'Please enter first name.'; return; }
// //     if (!lastname) { msg.className = 'error'; msg.textContent = 'Please enter last name.'; return; }
// //     if (!email) { msg.className = 'error'; msg.textContent = 'Please enter email address.'; return; }
// //     if (!phone) { msg.className = 'error'; msg.textContent = 'Please enter phone number.'; return; }
// //     if (!address1) { msg.className = 'error'; msg.textContent = 'Please enter address.'; return; }
// //     if (!city) { msg.className = 'error'; msg.textContent = 'Please enter city.'; return; }
// //     if (!country) { msg.className = 'error'; msg.textContent = 'Please select country.'; return; }

// //     msg.className = ''; msg.textContent = 'Sending verification code...';

// //     try {
// //       const res = await fetch('https://lara-otp.vercel.app/api/register', {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify({ company, firstname, lastname, email, phone, website, address1, address2, city, zip, country })
// //       });
// //       const data = await res.json();
// //       if (data.success) {
// //         currentEmail = email;
// //         document.getElementById('step-register').style.display = 'none';
// //         document.getElementById('step-verify').style.display = 'block';
// //         document.getElementById('verify-msg').textContent = `Code sent to ${email}`;
// //       } else {
// //         msg.className = 'error'; msg.textContent = data.error || 'Something went wrong.';
// //       }
// //     } catch (e) {
// //       msg.className = 'error'; msg.textContent = 'Server error. Try again.';
// //     }
// //   };

// //   window.otpVerify = async function () {
// //     const otp = document.getElementById('inp-otp').value.trim();
// //     const msg = document.getElementById('otp-msg2');

// //     if (!otp) { msg.className = 'error'; msg.textContent = 'Please enter verification code.'; return; }

// //     msg.className = ''; msg.textContent = 'Verifying...';

// //     try {
// //       const res = await fetch('https://lara-otp.vercel.app/api/verify', {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify({ email: currentEmail, otp })
// //       });
// //       const data = await res.json();
// //       if (data.success) {
// //         document.cookie = 'otp_verified=true; max-age=2592000; path=/';
// //         document.getElementById('otp-overlay').remove();
// //         window.location.href = 'https://laraleatherwholesale.com/';
// //       } else {
// //         msg.className = 'error'; msg.textContent = data.error || 'Invalid code.';
// //       }
// //     } catch (e) {
// //       msg.className = 'error'; msg.textContent = 'Server error. Try again.';
// //     }
// //   };

// //   window.otpResend = function () {
// //     document.getElementById('step-verify').style.display = 'none';
// //     document.getElementById('step-register').style.display = 'block';
// //   };
// // })();


// (function () {
//   if (document.cookie.indexOf('otp_verified=true') !== -1) return;

//   document.body.style.display = 'none';

//   const style = document.createElement('style');
//   style.innerHTML = `
//     #otp-overlay {
//       position: fixed;
//       top: 0; left: 0;
//       width: 100%; height: 100%;
//       z-index: 99999;
//       display: flex;
//       align-items: flex-start;
//       justify-content: center;
//       font-family: sans-serif;
//       overflow-y: auto;
//       padding: 20px 0;
//     }
//     #otp-overlay-bg {
//       position: fixed;
//       top: 0; left: 0;
//       width: 100%; height: 100%;
//       background-image: url('https://cdn.shopify.com/s/files/1/0975/0600/1212/files/WhatsApp_Image_2026-06-10_at_1.51.05_PM.jpg?v=1781124743');
//       background-size: cover;
//       background-position: center;
//       background-repeat: no-repeat;
//       background-color: rgba(0,0,0,0.6);
//       background-blend-mode: darken;
//       z-index: -1;
//     }
//     #otp-box {
//       position: relative;
//       z-index: 2;
//       background: #fff;
//       border: 1px solid #ddd;
//       border-radius: 12px;
//       padding: 30px;
//       width: 90%;
//       max-width: 500px;
//       margin: 20px auto;
//       box-sizing: border-box;
//       animation: zoomInUp 0.9s cubic-bezier(0.165, 0.84, 0.44, 1);
//     }
//     @keyframes zoomInUp {
//       0% { transform: translateY(80px) scale(0.8); opacity: 0; }
//       60% { transform: translateY(-8px) scale(1.02); opacity: 1; }
//       100% { transform: translateY(0) scale(1); opacity: 1; }
//     }
//     #otp-box h2 {
//       margin-bottom: 4px;
//       font-size: 28px;
//       color: #111;
//       text-align: center;
//       font-weight: 700 !important;
//     }
//     .subtitle {
//       color: #666;
//       font-size: 13px;
//       margin-bottom: 20px;
//       text-align: center;
//     }
//     .form-row {
//       display: flex;
//       gap: 10px;
//       margin-bottom: 10px;
//     }
//     .form-group {
//       display: flex;
//       flex-direction: column;
//       flex: 1;
//       margin-bottom: 10px;
//     }
//     .form-group label {
//       font-size: 13px;
//       color: #111 !important;
//       margin-bottom: 3px;
//       font-weight: 700 !important;
//       background: #f8f8f8;
//       padding: 2px 6px;
//       border-radius: 4px;
//     }
//     .form-group input {
//       padding: 10px 12px;
//       border: 1px solid #ddd;
//       border-radius: 6px;
//       font-size: 13px;
//       box-sizing: border-box;
//       width: 100%;
//     }
//     .form-group select {
//       padding: 10px 12px;
//       border: 1px solid #ddd;
//       border-radius: 6px;
//       font-size: 13px;
//       box-sizing: border-box;
//       width: 100%;
//     }
//     .required { color: red; }
//     .section-title {
//       font-size: 13px !important;
//       font-weight: 500 !important;
//       font-style: italic !important;
//       color: #af4a4aff !important;
//       letter-spacing: 0.3px;
//       margin: 8px 0 4px;
//       border-bottom: 1px solid #eee;
//       padding-bottom: 2px;
//       text-transform: none !important;
//     }
//     button.primary {
//       width: 100%;
//       padding: 12px;
//       background: #111;
//       color: #fff;
//       border: none;
//       border-radius: 8px;
//       font-size: 14px;
//       cursor: pointer;
//       margin-top: 10px;
//     }
//     button.primary:hover { background: #333; }
//     button.secondary {
//       width: 100%;
//       padding: 12px;
//       background: #fff;
//       color: #111;
//       border: 1px solid #ddd;
//       border-radius: 8px;
//       font-size: 14px;
//       cursor: pointer;
//       margin-top: 8px;
//     }
//     button.secondary:hover { background: #f5f5f5; }
//     #otp-msg, #otp-msg2, #login-msg {
//       font-size: 12px;
//       margin-top: 6px;
//       min-height: 18px;
//       text-align: center;
//     }
//     .error { color: red; }
//     .success { color: green; }
//     .divider {
//       text-align: center;
//       color: #999;
//       font-size: 12px;
//       margin: 12px 0;
//       position: relative;
//     }
//     .divider::before, .divider::after {
//       content: '';
//       position: absolute;
//       top: 50%;
//       width: 42%;
//       height: 1px;
//       background: #eee;
//     }
//     .divider::before { left: 0; }
//     .divider::after { right: 0; }

//     @media (max-width: 768px) {
//       #otp-box {
//         width: 78% !important;
//         max-width: 78% !important;
//         margin: 15px auto !important;
//         padding: 16px !important;
//       }
//       #otp-box h2 { font-size: 20px !important; }
//       .section-title { font-size: 11px !important; }
//       .form-group label { font-size: 11px !important; }
//       .form-group input, .form-group select { font-size: 13px !important; padding: 8px !important; }
//       .form-row { flex-direction: column !important; gap: 0 !important; }
//       button.primary, button.secondary { padding: 11px !important; font-size: 13px !important; }
//     }
//   `;
//   document.head.appendChild(style);

//   const overlay = document.createElement('div');
//   overlay.id = 'otp-overlay';

//   const bg = document.createElement('div');
//   bg.id = 'otp-overlay-bg';

//   const box = document.createElement('div');
//   box.id = 'otp-box';
//   box.innerHTML = `
//     <!-- Landing Screen -->
//     <div id="step-landing">
//       <h2>Welcome to Lara Leather</h2>
//       <p class="subtitle">Wholesale Store — Members Only</p>
//       <button class="primary" onclick="showRegister()">New here? Register Now</button>
//       <div class="divider">or</div>
//       <button class="secondary" onclick="showLogin()">Already have an account? Login</button>
//     </div>

//     <!-- Register Form -->
//     <div id="step-register" style="display:none;">
//       <h2>Welcome to Lara Leather</h2>
//       <p class="subtitle">Please register to access our wholesale store</p>

//       <div class="section-title">Business Information</div>
//       <div class="form-group">
//         <label>Company Name <span class="required">*</span></label>
//         <input type="text" id="inp-company" placeholder="Your company name" />
//       </div>
//       <div class="form-row">
//         <div class="form-group">
//           <label>First Name <span class="required">*</span></label>
//           <input type="text" id="inp-firstname" placeholder="First name" />
//         </div>
//         <div class="form-group">
//           <label>Last Name <span class="required">*</span></label>
//           <input type="text" id="inp-lastname" placeholder="Last name" />
//         </div>
//       </div>
//       <div class="form-group">
//         <label>Email Address <span class="required">*</span></label>
//         <input type="email" id="inp-email" placeholder="your@email.com" />
//       </div>
//       <div class="form-group">
//         <label>Phone Number <span class="required">*</span></label>
//         <input type="tel" id="inp-phone" placeholder="+1 234 567 8900" />
//       </div>

//       <div class="section-title">Business Details</div>
//       <div class="form-group">
//         <label>Website</label>
//         <input type="text" id="inp-website" placeholder="www.yourwebsite.com" />
//       </div>

//       <div class="section-title">Address</div>
//       <div class="form-group">
//         <label>Address Line 1 <span class="required">*</span></label>
//         <input type="text" id="inp-address1" placeholder="Street address" />
//       </div>
//       <div class="form-group">
//         <label>Address Line 2</label>
//         <input type="text" id="inp-address2" placeholder="Apt, suite, unit, etc." />
//       </div>
//       <div class="form-row">
//         <div class="form-group">
//           <label>City <span class="required">*</span></label>
//           <input type="text" id="inp-city" placeholder="City" />
//         </div>
//         <div class="form-group">
//           <label>ZIP / Postal Code</label>
//           <input type="text" id="inp-zip" placeholder="ZIP code" />
//         </div>
//       </div>
//       <div class="form-group">
//         <label>Country <span class="required">*</span></label>
//         <select id="inp-country">
//           <option value="">Select a country</option>
//           <option>United States</option>
//           <option>United Kingdom</option>
//           <option>Canada</option>
//           <option>Australia</option>
//           <option>Pakistan</option>
//           <option>UAE</option>
//           <option>Germany</option>
//           <option>France</option>
//           <option>Italy</option>
//           <option>Spain</option>
//           <option>Netherlands</option>
//           <option>Other</option>
//         </select>
//       </div>

//       <div class="section-title">Create Login Details</div>
//       <div class="form-group">
//         <label>Email (Username) <span class="required">*</span></label>
//         <input type="email" id="inp-login-email" placeholder="your@email.com" />
//       </div>
//       <div class="form-group">
//         <label>Password <span class="required">*</span></label>
//         <input type="password" id="inp-password" placeholder="Create a password" />
//       </div>

//       <button class="primary" onclick="otpSendCode()">Submit Application</button>
//       <div class="divider">or</div>
//       <button class="secondary" onclick="showLanding()">Back</button>
//       <div id="otp-msg"></div>
//     </div>

//     <!-- Waiting Screen -->
//     <div id="step-waiting" style="display:none;">
//       <div style="text-align:center;padding:20px 0;">
//         <h2 style="color:#111;">⏳ Application Submitted!</h2>
//         <p style="color:#666;font-size:14px;">Thank you! Please wait while we review your application...</p>
//         <div id="status-msg" style="margin-top:16px;font-size:13px;color:#888;">Still waiting for approval...</div>
//       </div>
//     </div>

//     <!-- Login Screen -->
//     <div id="step-login" style="display:none;">
//       <h2>Login to Store</h2>
//       <p class="subtitle">Enter your login details to access the store</p>
//       <div class="form-group">
//         <label>Email Address <span class="required">*</span></label>
//         <input type="email" id="login-email" placeholder="your@email.com" />
//       </div>
//       <div class="form-group">
//         <label>Password <span class="required">*</span></label>
//         <input type="password" id="login-password" placeholder="Your password" />
//       </div>
//       <button class="primary" onclick="doLogin()">Login to Store</button>
//       <div class="divider">or</div>
//       <button class="secondary" onclick="showLanding()">Back</button>
//       <div id="login-msg"></div>
//     </div>
//   `;

//   overlay.appendChild(bg);
//   overlay.appendChild(box);
//   document.body.appendChild(overlay);
//   document.body.style.display = 'block';

//   let currentEmail = '';

//   window.showLanding = function() {
//     document.getElementById('step-landing').style.display = 'block';
//     document.getElementById('step-register').style.display = 'none';
//     document.getElementById('step-login').style.display = 'none';
//     document.getElementById('step-waiting').style.display = 'none';
//   };

//   window.showRegister = function() {
//     document.getElementById('step-landing').style.display = 'none';
//     document.getElementById('step-register').style.display = 'block';
//     document.getElementById('step-login').style.display = 'none';
//     document.getElementById('step-waiting').style.display = 'none';
//   };

//   window.showLogin = function() {
//     document.getElementById('step-landing').style.display = 'none';
//     document.getElementById('step-register').style.display = 'none';
//     document.getElementById('step-login').style.display = 'block';
//     document.getElementById('step-waiting').style.display = 'none';
//   };

//   window.otpSendCode = async function () {
//     const company = document.getElementById('inp-company').value.trim();
//     const firstname = document.getElementById('inp-firstname').value.trim();
//     const lastname = document.getElementById('inp-lastname').value.trim();
//     const email = document.getElementById('inp-email').value.trim();
//     const phone = document.getElementById('inp-phone').value.trim();
//     const website = document.getElementById('inp-website').value.trim();
//     const address1 = document.getElementById('inp-address1').value.trim();
//     const address2 = document.getElementById('inp-address2').value.trim();
//     const city = document.getElementById('inp-city').value.trim();
//     const zip = document.getElementById('inp-zip').value.trim();
//     const country = document.getElementById('inp-country').value;
//     const loginEmail = document.getElementById('inp-login-email').value.trim();
//     const password = document.getElementById('inp-password').value.trim();
//     const msg = document.getElementById('otp-msg');

//     if (!company) { msg.className = 'error'; msg.textContent = 'Please enter company name.'; return; }
//     if (!firstname) { msg.className = 'error'; msg.textContent = 'Please enter first name.'; return; }
//     if (!lastname) { msg.className = 'error'; msg.textContent = 'Please enter last name.'; return; }
//     if (!email) { msg.className = 'error'; msg.textContent = 'Please enter email address.'; return; }
//     if (!phone) { msg.className = 'error'; msg.textContent = 'Please enter phone number.'; return; }
//     if (!address1) { msg.className = 'error'; msg.textContent = 'Please enter address.'; return; }
//     if (!city) { msg.className = 'error'; msg.textContent = 'Please enter city.'; return; }
//     if (!country) { msg.className = 'error'; msg.textContent = 'Please select country.'; return; }
//     if (!loginEmail) { msg.className = 'error'; msg.textContent = 'Please enter login email.'; return; }
//     if (!password) { msg.className = 'error'; msg.textContent = 'Please create a password.'; return; }
//     if (password.length < 6) { msg.className = 'error'; msg.textContent = 'Password must be at least 6 characters.'; return; }

//     msg.className = ''; msg.textContent = 'Submitting...';

//     try {
//       const res = await fetch('https://lara-otp.vercel.app/api/register', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ company, firstname, lastname, email, phone, website, address1, address2, city, zip, country, loginEmail, password })
//       });
//       const data = await res.json();
//       if (data.success) {
//         currentEmail = loginEmail;
//         document.getElementById('step-register').style.display = 'none';
//         document.getElementById('step-waiting').style.display = 'block';
//         checkApproval(loginEmail);
//       } else {
//         msg.className = 'error'; msg.textContent = data.error || 'Something went wrong.';
//       }
//     } catch (e) {
//       msg.className = 'error'; msg.textContent = 'Server error. Try again.';
//     }
//   };

//   window.doLogin = async function() {
//     const email = document.getElementById('login-email').value.trim();
//     const password = document.getElementById('login-password').value.trim();
//     const msg = document.getElementById('login-msg');

//     if (!email) { msg.className = 'error'; msg.textContent = 'Please enter email.'; return; }
//     if (!password) { msg.className = 'error'; msg.textContent = 'Please enter password.'; return; }

//     msg.className = ''; msg.textContent = 'Logging in...';

//     try {
//       const res = await fetch('https://lara-otp.vercel.app/api/login', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email, password })
//       });
//       const data = await res.json();
//       if (data.success) {
//         document.cookie = 'otp_verified=true; max-age=2592000; path=/';
//         window.location.href = 'https://laraleatherwholesale.com/';
//       } else {
//         msg.className = 'error'; msg.textContent = data.error || 'Invalid email or password.';
//       }
//     } catch(e) {
//       msg.className = 'error'; msg.textContent = 'Server error. Try again.';
//     }
//   };

//   async function checkApproval(email) {
//     const interval = setInterval(async () => {
//       try {
//         const res = await fetch('https://lara-otp.vercel.app/api/check?email=' + encodeURIComponent(email));
//         const data = await res.json();
//         if (data.approved) {
//           clearInterval(interval);
//           document.cookie = 'otp_verified=true; max-age=2592000; path=/';
//           window.location.href = 'https://laraleatherwholesale.com/';
//         } else if (data.rejected) {
//           clearInterval(interval);
//           document.getElementById('otp-box').innerHTML = `
//             <div style="text-align:center;padding:40px 20px;">
//               <h2 style="color:red;">❌ Application Rejected</h2>
//               <p style="color:#666;font-size:14px;">Unfortunately your application has not been approved at this time.<br>Please contact us for more information.</p>
//             </div>
//           `;
//         } else {
//           document.getElementById('status-msg').textContent = 'Still waiting for approval...';
//         }
//       } catch(e) {}
//     }, 5000);
//   }

// })();




































// (function () {
//   if (document.cookie.indexOf('otp_verified=true') !== -1) return;
//   if (window.location.href.indexOf('admin') !== -1) return;
//   if (window.Shopify && window.Shopify.designMode) return;
//   document.body.style.display = 'none';

//   const style = document.createElement('style');
//   style.innerHTML = `
//     #otp-overlay {
//       position: fixed;
//       top: 0; left: 0;
//       width: 100%; height: 100%;
//       z-index: 99999;
//       display: flex;
//       align-items: flex-start;
//       justify-content: center;
//       font-family: sans-serif;
//       overflow-y: auto;
//       padding: 20px 0;
//       background-image: url('https://cdn.shopify.com/s/files/1/0975/0600/1212/files/WhatsApp_Image_2026-06-10_at_1.51.05_PM.jpg?v=1781124743');
//       background-size: cover;
//       background-position: center;
//       background-repeat: no-repeat;
//       background-color: rgba(0,0,0,0.6);
//       background-blend-mode: darken;
//     }
//     #otp-box {
//       position: relative;
//       z-index: 2;
//       background: #fff;
//       border: 1px solid #ddd;
//       border-radius: 12px;
//       padding: 20px;
//       width: 70%;
//       max-width: 500px;
//       margin: 40px auto;
//       box-sizing: border-box;
//       animation: zoomInUp 0.9s cubic-bezier(0.165, 0.84, 0.44, 1);
//     }
//     @keyframes zoomInUp {
//       0% { transform: translateY(80px) scale(0.8); opacity: 0; }
//       60% { transform: translateY(-8px) scale(1.02); opacity: 1; }
//       100% { transform: translateY(0) scale(1); opacity: 1; }
//     }
//     #otp-box h2 {
//       margin-bottom: 4px;
//       font-size: 28px !important;
//       color: #111;
//       text-align: center;
//       font-weight: 700 !important;
//     }
//     .subtitle {
//       color: #666;
//       font-size: 13px;
//       margin-bottom: 20px;
//       text-align: center;
//     }
//     .form-row {
//       display: flex;
//       gap: 10px;
//       margin-bottom: 10px;
//     }
//     .form-group {
//       display: flex;
//       flex-direction: column;
//       flex: 1;
//       margin-bottom: 10px;
//     }
//     .form-group label {
//       font-size: 13px;
//       color: #111 !important;
//       margin-bottom: 3px;
//       font-weight: 700 !important;
//       background: #f8f8f8;
//       padding: 2px 6px;
//       border-radius: 4px;
//     }
//     .form-group input,
//     .form-group select {
//       padding: 8px 10px;
//       border: 1px solid #ddd;
//       border-radius: 6px;
//       font-size: 13px;
//       box-sizing: border-box;
//       width: 100%;
//     }
//     .required { color: red; }
//     .section-title {
//       font-size: 24px !important;
//       font-weight: 700 !important;
//       font-style: italic !important;
//       color: #af4a4aff !important;
//       letter-spacing: 0.3px;
//       margin: 8px 0 4px;
//       border-bottom: 1px solid #eee;
//       padding-bottom: 2px;
//       text-transform: none !important;
//     }
//     button.primary {
//       width: 100%;
//       padding: 11px;
//       background: #111;
//       color: #fff;
//       border: none;
//       border-radius: 8px;
//       font-size: 14px;
//       cursor: pointer;
//       margin-top: 10px;
//     }
//     button.primary:hover { background: #333; }
//     button.secondary {
//       width: 100%;
//       padding: 11px;
//       background: #fff;
//       color: #111;
//       border: 1px solid #ddd;
//       border-radius: 8px;
//       font-size: 14px;
//       cursor: pointer;
//       margin-top: 8px;
//     }
//     button.secondary:hover { background: #f5f5f5; }
//     #otp-msg, #login-msg {
//       font-size: 12px;
//       margin-top: 6px;
//       min-height: 18px;
//       text-align: center;
//     }
//     .error { color: red; }
//     .success { color: green; }
//     .divider {
//       text-align: center;
//       color: #999;
//       font-size: 12px;
//       margin: 12px 0;
//       position: relative;
//     }
//     .divider::before, .divider::after {
//       content: '';
//       position: absolute;
//       top: 50%;
//       width: 42%;
//       height: 1px;
//       background: #eee;
//     }
//     .divider::before { left: 0; }
//     .divider::after { right: 0; }

//     @media (max-width: 768px) {
//       #otp-box {
//         width: 76% !important;
//         max-width: 76% !important;
//         margin: 12px auto !important;
//         padding: 12px !important;
//       }
//       #otp-box h2 { font-size: 20px !important; }
//       .section-title { font-size: 15px !important; }
//       .form-group label { font-size: 11px !important; }
//       .form-group input, .form-group select { font-size: 12px !important; padding: 7px 8px !important; }
//       .form-row { flex-direction: column !important; gap: 0 !important; }
//       button.primary, button.secondary { padding: 11px !important; font-size: 13px !important; }
//     }
//   `;
//   document.head.appendChild(style);

//   const overlay = document.createElement('div');
//   overlay.id = 'otp-overlay';

//   const box = document.createElement('div');
//   box.id = 'otp-box';
//   box.innerHTML = `
//     <div id="step-landing">
//       <h2>Welcome to Lara Leather</h2>
//       <p class="subtitle">Wholesale Store — Members Only</p>
//       <button class="primary" onclick="showRegister()">New here? Register Now</button>
//       <div class="divider">or</div>
//       <button class="secondary" onclick="showLogin()">Already have an account? Login</button>
//     </div>

//     <div id="step-register" style="display:none;">
//       <h2>Welcome to Lara Leather</h2>
//       <p class="subtitle">Please register to access our wholesale store</p>

//       <div class="section-title">Business Information</div>
//       <div class="form-group">
//         <label>Company Name <span class="required">*</span></label>
//         <input type="text" id="inp-company" placeholder="Your company name" />
//       </div>
//       <div class="form-row">
//         <div class="form-group">
//           <label>First Name <span class="required">*</span></label>
//           <input type="text" id="inp-firstname" placeholder="First name" />
//         </div>
//         <div class="form-group">
//           <label>Last Name <span class="required">*</span></label>
//           <input type="text" id="inp-lastname" placeholder="Last name" />
//         </div>
//       </div>
//       <div class="form-group">
//         <label>Email Address <span class="required">*</span></label>
//         <input type="email" id="inp-email" placeholder="your@email.com" />
//       </div>
//       <div class="form-group">
//         <label>Phone Number <span class="required">*</span></label>
//         <input type="tel" id="inp-phone" placeholder="+1 234 567 8900" />
//       </div>

//       <div class="section-title">Business Details</div>
//       <div class="form-group">
//         <label>Website</label>
//         <input type="text" id="inp-website" placeholder="www.yourwebsite.com" />
//       </div>

//       <div class="section-title">Address</div>
//       <div class="form-group">
//         <label>Address Line 1 <span class="required">*</span></label>
//         <input type="text" id="inp-address1" placeholder="Street address" />
//       </div>
//       <div class="form-group">
//         <label>Address Line 2</label>
//         <input type="text" id="inp-address2" placeholder="Apt, suite, unit, etc." />
//       </div>
//       <div class="form-row">
//         <div class="form-group">
//           <label>City <span class="required">*</span></label>
//           <input type="text" id="inp-city" placeholder="City" />
//         </div>
//         <div class="form-group">
//           <label>ZIP / Postal Code</label>
//           <input type="text" id="inp-zip" placeholder="ZIP code" />
//         </div>
//       </div>
//       <div class="form-group">
//         <label>Country <span class="required">*</span></label>
//         <select id="inp-country">
//           <option value="">Select a country</option>
//           <option>United States</option>
//           <option>United Kingdom</option>
//           <option>Canada</option>
//           <option>Australia</option>
//           <option>Pakistan</option>
//           <option>UAE</option>
//           <option>Germany</option>
//           <option>France</option>
//           <option>Italy</option>
//           <option>Spain</option>
//           <option>Netherlands</option>
//           <option>Other</option>
//         </select>
//       </div>

//       <div class="section-title">Create Login Details</div>
//       <div class="form-group">
//         <label>Login Email <span class="required">*</span></label>
//         <input type="email" id="inp-login-email" placeholder="your@email.com" />
//       </div>
//       <div class="form-group">
//         <label>Password <span class="required">*</span></label>
//       <div style="position:relative;">
//   <input type="password" id="inp-password" placeholder="Create a password (min 6 characters)" style="padding-right:40px;" />
//   <span onclick="togglePass('inp-password')" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);cursor:pointer;font-size:16px;">👁</span>
// </div>
//       </div>

//       <button class="primary" onclick="otpSendCode()">Submit Application</button>
//       <div class="divider">or</div>
//       <button class="secondary" onclick="showLanding()">← Back</button>
//       <div id="otp-msg"></div>
//     </div>

//     <div id="step-waiting" style="display:none;">
//       <div style="text-align:center;padding:20px 0;">
//         <h2 style="color:#111;">⏳ Application Submitted!</h2>
//         <p style="color:#666;font-size:14px;">Thank you! Please wait while we review your application...</p>
//         <div id="status-msg" style="margin-top:16px;font-size:13px;color:#888;">Still waiting for approval...</div>
//       </div>
//     </div>

//     <div id="step-login" style="display:none;">
//       <h2>Login to Store</h2>
//       <p class="subtitle">Enter your login details to access the store</p>
//       <div class="form-group">
//         <label>Email Address <span class="required">*</span></label>
//         <input type="email" id="login-email" placeholder="your@email.com" />
//       </div>
//       <div class="form-group">
//         <label>Password <span class="required">*</span></label>
//       <div style="position:relative;">
//   <input type="password" id="login-password" placeholder="Your password" style="padding-right:40px;" />
//   <span onclick="togglePass('login-password')" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);cursor:pointer;font-size:16px;">👁</span>
// </div>
//       </div>
//       <button class="primary" onclick="doLogin()">Login to Store</button>
//       <div class="divider">or</div>
//       <button class="secondary" onclick="showLanding()">← Back</button>
//       <div id="login-msg"></div>
//     </div>
//   `;

//   overlay.appendChild(box);
//   document.body.appendChild(overlay);
//   document.body.style.display = 'block';

//   window.showLanding = function() {
//     document.getElementById('step-landing').style.display = 'block';
//     document.getElementById('step-register').style.display = 'none';
//     document.getElementById('step-login').style.display = 'none';
//     document.getElementById('step-waiting').style.display = 'none';
//   };

//   window.showRegister = function() {
//     document.getElementById('step-landing').style.display = 'none';
//     document.getElementById('step-register').style.display = 'block';
//     document.getElementById('step-login').style.display = 'none';
//     document.getElementById('step-waiting').style.display = 'none';
//   };

//   window.showLogin = function() {
//     document.getElementById('step-landing').style.display = 'none';
//     document.getElementById('step-register').style.display = 'none';
//     document.getElementById('step-login').style.display = 'block';
//     document.getElementById('step-waiting').style.display = 'none';
//   };

//   window.otpSendCode = async function () {
//     const company = document.getElementById('inp-company').value.trim();
//     const firstname = document.getElementById('inp-firstname').value.trim();
//     const lastname = document.getElementById('inp-lastname').value.trim();
//     const email = document.getElementById('inp-email').value.trim();
//     const phone = document.getElementById('inp-phone').value.trim();
//     const website = document.getElementById('inp-website').value.trim();
//     const address1 = document.getElementById('inp-address1').value.trim();
//     const address2 = document.getElementById('inp-address2').value.trim();
//     const city = document.getElementById('inp-city').value.trim();
//     const zip = document.getElementById('inp-zip').value.trim();
//     const country = document.getElementById('inp-country').value;
//     const loginEmail = document.getElementById('inp-login-email').value.trim();
//     const password = document.getElementById('inp-password').value.trim();
//     const msg = document.getElementById('otp-msg');

//     if (!company) { msg.className = 'error'; msg.textContent = 'Please enter company name.'; return; }
//     if (!firstname) { msg.className = 'error'; msg.textContent = 'Please enter first name.'; return; }
//     if (!lastname) { msg.className = 'error'; msg.textContent = 'Please enter last name.'; return; }
//     if (!email) { msg.className = 'error'; msg.textContent = 'Please enter email address.'; return; }
//     if (!phone) { msg.className = 'error'; msg.textContent = 'Please enter phone number.'; return; }
//     if (!address1) { msg.className = 'error'; msg.textContent = 'Please enter address.'; return; }
//     if (!city) { msg.className = 'error'; msg.textContent = 'Please enter city.'; return; }
//     if (!country) { msg.className = 'error'; msg.textContent = 'Please select country.'; return; }
//     if (!loginEmail) { msg.className = 'error'; msg.textContent = 'Please enter login email.'; return; }
//     if (!password) { msg.className = 'error'; msg.textContent = 'Please create a password.'; return; }
//     if (password.length < 6) { msg.className = 'error'; msg.textContent = 'Password must be at least 6 characters.'; return; }

//     msg.className = ''; msg.textContent = 'Submitting...';

//     try {
//       const res = await fetch('https://lara-otp.vercel.app/api/register', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ company, firstname, lastname, email, phone, website, address1, address2, city, zip, country, loginEmail, password })
//       });
//       const data = await res.json();
//       if (data.success) {
//         document.getElementById('step-register').style.display = 'none';
//         document.getElementById('step-waiting').style.display = 'block';
//         checkApproval(loginEmail);
//       } else {
//         msg.className = 'error'; msg.textContent = data.error || 'Something went wrong.';
//       }
//     } catch (e) {
//       msg.className = 'error'; msg.textContent = 'Server error. Try again.';
//     }
//   };

//   window.doLogin = async function() {
//     const email = document.getElementById('login-email').value.trim();
//     const password = document.getElementById('login-password').value.trim();
//     const msg = document.getElementById('login-msg');

//     if (!email) { msg.className = 'error'; msg.textContent = 'Please enter email.'; return; }
//     if (!password) { msg.className = 'error'; msg.textContent = 'Please enter password.'; return; }

//     msg.className = ''; msg.textContent = 'Logging in...';

//     try {
//       const res = await fetch('https://lara-otp.vercel.app/api/login', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ email, password })
//       });
//       const data = await res.json();
//       if (data.success) {
//         document.cookie = 'otp_verified=true; max-age=2592000; path=/';
//         window.location.href = 'https://laraleatherwholesale.com/';
//       } else {
//         msg.className = 'error'; msg.textContent = data.error || 'Invalid email or password.';
//       }
//     } catch(e) {
//       msg.className = 'error'; msg.textContent = 'Server error. Try again.';
//     }
//   };

//   async function checkApproval(email) {
//     const interval = setInterval(async () => {
//       try {
//         const res = await fetch('https://lara-otp.vercel.app/api/check?email=' + encodeURIComponent(email));
//         const data = await res.json();
//         if (data.approved) {
//           clearInterval(interval);
//           document.cookie = 'otp_verified=true; max-age=2592000; path=/';
//           window.location.href = 'https://laraleatherwholesale.com/';
//         } else if (data.rejected) {
//           clearInterval(interval);
//           document.getElementById('otp-box').innerHTML = `
//             <div style="text-align:center;padding:40px 20px;">
//               <h2 style="color:red;">❌ Application Rejected</h2>
//               <p style="color:#666;font-size:14px;">Unfortunately your application has not been approved at this time.<br>Please contact us for more information.</p>
//             </div>
//           `;
//         } else {
//           document.getElementById('status-msg').textContent = 'Still waiting for approval...';
//         }
//       } catch(e) {}
//     }, 5000);
//   }

//   window.togglePass = function(id) {
//     const input = document.getElementById(id);
//     input.type = input.type === 'password' ? 'text' : 'password';
//   };
// })();




































(function () {
  if (document.cookie.indexOf('otp_verified=true') !== -1) return;
  if (window.location.href.indexOf('admin') !== -1) return;
  if (window.Shopify && window.Shopify.designMode) return;
  document.body.style.display = 'none';

  const style = document.createElement('style');
  style.innerHTML = `
    #otp-overlay {
      position: fixed;
      top: 0; left: 0;
      width: 100%; height: 100%;
      z-index: 99999;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      font-family: sans-serif;
      overflow-y: auto;
      padding: 20px 0;
      background-image: url('https://cdn.shopify.com/s/files/1/0975/0600/1212/files/WhatsApp_Image_2026-06-10_at_1.51.05_PM.jpg?v=1781124743');
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      background-color: rgba(0,0,0,0.6);
      background-blend-mode: darken;
    }
    #otp-box {
      position: relative;
      z-index: 2;
      background: #fff;
      border: 1px solid #ddd;
      border-radius: 12px;
      padding: 20px;
      width: 70%;
      max-width: 500px;
      margin: 40px auto;
      box-sizing: border-box;
      animation: zoomInUp 0.9s cubic-bezier(0.165, 0.84, 0.44, 1);
    }
    @keyframes zoomInUp {
      0% { transform: translateY(80px) scale(0.8); opacity: 0; }
      60% { transform: translateY(-8px) scale(1.02); opacity: 1; }
      100% { transform: translateY(0) scale(1); opacity: 1; }
    }
    #otp-box h2 {
      margin-bottom: 4px;
      font-size: 28px !important;
      color: #111;
      text-align: center;
      font-weight: 700 !important;
    }
    .subtitle {
      color: #666;
      font-size: 13px;
      margin-bottom: 20px;
      text-align: center;
    }
    .form-row {
      display: flex;
      gap: 10px;
      margin-bottom: 10px;
    }
    .form-group {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin-bottom: 10px;
    }
    .form-group label {
      font-size: 13px;
      color: #111 !important;
      margin-bottom: 3px;
      font-weight: 700 !important;
      background: #f8f8f8;
      padding: 2px 6px;
      border-radius: 4px;
    }
    .form-group input,
    .form-group select {
      padding: 8px 10px;
      border: 1px solid #ddd;
      border-radius: 6px;
      font-size: 13px;
      box-sizing: border-box;
      width: 100%;
    }
    .required { color: red; }
    .section-title {
      font-size: 24px !important;
      font-weight: 700 !important;
      font-style: italic !important;
      color: #af4a4aff !important;
      letter-spacing: 0.3px;
      margin: 8px 0 4px;
      border-bottom: 1px solid #eee;
      padding-bottom: 2px;
      text-transform: none !important;
    }
    button.primary {
      width: 100%;
      padding: 11px;
      background: #111;
      color: #fff;
      border: none;
      border-radius: 8px;
      font-size: 14px;
      cursor: pointer;
      margin-top: 10px;
    }
    button.primary:hover { background: #333; }
    button.secondary {
      width: 100%;
      padding: 11px;
      background: #fff;
      color: #111;
      border: 1px solid #ddd;
      border-radius: 8px;
      font-size: 14px;
      cursor: pointer;
      margin-top: 8px;
    }
    button.secondary:hover { background: #f5f5f5; }
    #otp-msg, #login-msg, #forgot-msg, #reset-msg {
      font-size: 12px;
      margin-top: 6px;
      min-height: 18px;
      text-align: center;
    }
    .error { color: red; }
    .success { color: green; }
    .divider {
      text-align: center;
      color: #999;
      font-size: 12px;
      margin: 12px 0;
      position: relative;
    }
    .divider::before, .divider::after {
      content: '';
      position: absolute;
      top: 50%;
      width: 42%;
      height: 1px;
      background: #eee;
    }
    .divider::before { left: 0; }
    .divider::after { right: 0; }
    .link-btn {
      background: none;
      border: none;
      color: #666;
      font-size: 12px;
      text-decoration: underline;
      cursor: pointer;
      display: block;
      width: 100%;
      text-align: center;
      margin-top: 10px;
      padding: 4px;
    }
    .link-btn:hover { color: #111; }

    @media (max-width: 768px) {
      #otp-box {
        width: 76% !important;
        max-width: 76% !important;
        margin: 12px auto !important;
        padding: 12px !important;
      }
      #otp-box h2 { font-size: 20px !important; }
      .section-title { font-size: 15px !important; }
      .form-group label { font-size: 11px !important; }
      .form-group input, .form-group select { font-size: 12px !important; padding: 7px 8px !important; }
      .form-row { flex-direction: column !important; gap: 0 !important; }
      button.primary, button.secondary { padding: 11px !important; font-size: 13px !important; }
    }
  `;
  document.head.appendChild(style);

  const overlay = document.createElement('div');
  overlay.id = 'otp-overlay';

  const box = document.createElement('div');
  box.id = 'otp-box';
  box.innerHTML = `
    <div id="step-landing">
      <h2>Welcome to Lara Leather</h2>
      <p class="subtitle">Wholesale Store — Members Only</p>
      <button class="primary" onclick="showRegister()">New here? Register Now</button>
      <div class="divider">or</div>
      <button class="secondary" onclick="showLogin()">Already have an account? Login</button>
    </div>

    <div id="step-register" style="display:none;">
      <h2>Welcome to Lara Leather</h2>
      <p class="subtitle">Please register to access our wholesale store</p>

      <div class="section-title">Business Information</div>
      <div class="form-group">
        <label>Company Name <span class="required">*</span></label>
        <input type="text" id="inp-company" placeholder="Your company name" />
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>First Name <span class="required">*</span></label>
          <input type="text" id="inp-firstname" placeholder="First name" />
        </div>
        <div class="form-group">
          <label>Last Name <span class="required">*</span></label>
          <input type="text" id="inp-lastname" placeholder="Last name" />
        </div>
      </div>
      <div class="form-group">
        <label>Email Address <span class="required">*</span></label>
        <input type="email" id="inp-email" placeholder="your@email.com" />
      </div>
      <div class="form-group">
        <label>Phone Number <span class="required">*</span></label>
        <input type="tel" id="inp-phone" placeholder="+1 234 567 8900" />
      </div>

      <div class="section-title">Business Details</div>
      <div class="form-group">
        <label>Website</label>
        <input type="text" id="inp-website" placeholder="www.yourwebsite.com" />
      </div>

      <div class="section-title">Address</div>
      <div class="form-group">
        <label>Address Line 1 <span class="required">*</span></label>
        <input type="text" id="inp-address1" placeholder="Street address" />
      </div>
      <div class="form-group">
        <label>Address Line 2</label>
        <input type="text" id="inp-address2" placeholder="Apt, suite, unit, etc." />
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>City <span class="required">*</span></label>
          <input type="text" id="inp-city" placeholder="City" />
        </div>
        <div class="form-group">
          <label>ZIP / Postal Code</label>
          <input type="text" id="inp-zip" placeholder="ZIP code" />
        </div>
      </div>
      <div class="form-group">
        <label>Country <span class="required">*</span></label>
        <select id="inp-country">
          <option value="">Select a country</option>
          <option>United States</option>
          <option>United Kingdom</option>
          <option>Canada</option>
          <option>Australia</option>
          <option>Pakistan</option>
          <option>UAE</option>
          <option>Germany</option>
          <option>France</option>
          <option>Italy</option>
          <option>Spain</option>
          <option>Netherlands</option>
          <option>Other</option>
        </select>
      </div>

      <div class="section-title">Create Login Details</div>
      <div class="form-group">
        <label>Login Email <span class="required">*</span></label>
        <input type="email" id="inp-login-email" placeholder="your@email.com" />
      </div>
      <div class="form-group">
        <label>Password <span class="required">*</span></label>
      <div style="position:relative;">
  <input type="password" id="inp-password" placeholder="Create a password (min 6 characters)" style="padding-right:40px;" />
  <span onclick="togglePass('inp-password')" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);cursor:pointer;font-size:16px;">👁</span>
</div>
      </div>

      <button class="primary" onclick="otpSendCode()">Submit Application</button>
      <div class="divider">or</div>
      <button class="secondary" onclick="showLanding()">← Back</button>
      <div id="otp-msg"></div>
    </div>

    <div id="step-waiting" style="display:none;">
      <div style="text-align:center;padding:20px 0;">
        <h2 style="color:#111;">⏳ Application Submitted!</h2>
        <p style="color:#666;font-size:14px;">Thank you! Please wait while we review your application...</p>
        <div id="status-msg" style="margin-top:16px;font-size:13px;color:#888;">Still waiting for approval...</div>
      </div>
    </div>

    <div id="step-login" style="display:none;">
      <h2>Login to Store</h2>
      <p class="subtitle">Enter your login details to access the store</p>
      <div class="form-group">
        <label>Email Address <span class="required">*</span></label>
        <input type="email" id="login-email" placeholder="your@email.com" />
      </div>
      <div class="form-group">
        <label>Password <span class="required">*</span></label>
      <div style="position:relative;">
  <input type="password" id="login-password" placeholder="Your password" style="padding-right:40px;" />
  <span onclick="togglePass('login-password')" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);cursor:pointer;font-size:16px;">👁</span>
</div>
      </div>
      <button class="primary" onclick="doLogin()">Login to Store</button>
      <button class="link-btn" onclick="showForgot()">Forgot Password?</button>
      <div class="divider">or</div>
      <button class="secondary" onclick="showLanding()">← Back</button>
      <div id="login-msg"></div>
    </div>

    <div id="step-forgot" style="display:none;">
      <h2>Reset Password</h2>
      <p class="subtitle">Enter your account email — we'll send you a reset code</p>
      <div class="form-group">
        <label>Email Address <span class="required">*</span></label>
        <input type="email" id="forgot-email" placeholder="your@email.com" />
      </div>
      <button class="primary" onclick="doForgotPassword()">Send Reset Code</button>
      <div class="divider">or</div>
      <button class="secondary" onclick="showLogin()">← Back to Login</button>
      <div id="forgot-msg"></div>
    </div>

    <div id="step-reset" style="display:none;">
      <h2>Enter Reset Code</h2>
      <p class="subtitle">Check your email for the 6-digit code, then set a new password</p>
      <div class="form-group">
        <label>Reset Code <span class="required">*</span></label>
        <input type="text" id="reset-otp" placeholder="123456" maxlength="6" />
      </div>
      <div class="form-group">
        <label>New Password <span class="required">*</span></label>
        <div style="position:relative;">
          <input type="password" id="reset-password" placeholder="New password (min 6 characters)" style="padding-right:40px;" />
          <span onclick="togglePass('reset-password')" style="position:absolute;right:10px;top:50%;transform:translateY(-50%);cursor:pointer;font-size:16px;">👁</span>
        </div>
      </div>
      <button class="primary" onclick="doResetPassword()">Reset Password</button>
      <button class="link-btn" onclick="doForgotPassword(true)">Resend Code</button>
      <div class="divider">or</div>
      <button class="secondary" onclick="showLogin()">← Back to Login</button>
      <div id="reset-msg"></div>
    </div>
  `;

  overlay.appendChild(box);
  document.body.appendChild(overlay);
  document.body.style.display = 'block';

  let resetEmail = '';

  window.showLanding = function() {
    document.getElementById('step-landing').style.display = 'block';
    document.getElementById('step-register').style.display = 'none';
    document.getElementById('step-login').style.display = 'none';
    document.getElementById('step-waiting').style.display = 'none';
    document.getElementById('step-forgot').style.display = 'none';
    document.getElementById('step-reset').style.display = 'none';
  };

  window.showRegister = function() {
    document.getElementById('step-landing').style.display = 'none';
    document.getElementById('step-register').style.display = 'block';
    document.getElementById('step-login').style.display = 'none';
    document.getElementById('step-waiting').style.display = 'none';
    document.getElementById('step-forgot').style.display = 'none';
    document.getElementById('step-reset').style.display = 'none';
  };

  window.showLogin = function() {
    document.getElementById('step-landing').style.display = 'none';
    document.getElementById('step-register').style.display = 'none';
    document.getElementById('step-login').style.display = 'block';
    document.getElementById('step-waiting').style.display = 'none';
    document.getElementById('step-forgot').style.display = 'none';
    document.getElementById('step-reset').style.display = 'none';
  };

  window.showForgot = function() {
    document.getElementById('step-landing').style.display = 'none';
    document.getElementById('step-register').style.display = 'none';
    document.getElementById('step-login').style.display = 'none';
    document.getElementById('step-waiting').style.display = 'none';
    document.getElementById('step-forgot').style.display = 'block';
    document.getElementById('step-reset').style.display = 'none';
  };

  window.otpSendCode = async function () {
    const company = document.getElementById('inp-company').value.trim();
    const firstname = document.getElementById('inp-firstname').value.trim();
    const lastname = document.getElementById('inp-lastname').value.trim();
    const email = document.getElementById('inp-email').value.trim();
    const phone = document.getElementById('inp-phone').value.trim();
    const website = document.getElementById('inp-website').value.trim();
    const address1 = document.getElementById('inp-address1').value.trim();
    const address2 = document.getElementById('inp-address2').value.trim();
    const city = document.getElementById('inp-city').value.trim();
    const zip = document.getElementById('inp-zip').value.trim();
    const country = document.getElementById('inp-country').value;
    const loginEmail = document.getElementById('inp-login-email').value.trim();
    const password = document.getElementById('inp-password').value.trim();
    const msg = document.getElementById('otp-msg');

    if (!company) { msg.className = 'error'; msg.textContent = 'Please enter company name.'; return; }
    if (!firstname) { msg.className = 'error'; msg.textContent = 'Please enter first name.'; return; }
    if (!lastname) { msg.className = 'error'; msg.textContent = 'Please enter last name.'; return; }
    if (!email) { msg.className = 'error'; msg.textContent = 'Please enter email address.'; return; }
    if (!phone) { msg.className = 'error'; msg.textContent = 'Please enter phone number.'; return; }
    if (!address1) { msg.className = 'error'; msg.textContent = 'Please enter address.'; return; }
    if (!city) { msg.className = 'error'; msg.textContent = 'Please enter city.'; return; }
    if (!country) { msg.className = 'error'; msg.textContent = 'Please select country.'; return; }
    if (!loginEmail) { msg.className = 'error'; msg.textContent = 'Please enter login email.'; return; }
    if (!password) { msg.className = 'error'; msg.textContent = 'Please create a password.'; return; }
    if (password.length < 6) { msg.className = 'error'; msg.textContent = 'Password must be at least 6 characters.'; return; }

    msg.className = ''; msg.textContent = 'Submitting...';

    try {
      const res = await fetch('https://lara-otp.vercel.app/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ company, firstname, lastname, email, phone, website, address1, address2, city, zip, country, loginEmail, password })
      });
      const data = await res.json();
      if (data.success) {
        document.getElementById('step-register').style.display = 'none';
        document.getElementById('step-waiting').style.display = 'block';
        checkApproval(loginEmail);
      } else {
        msg.className = 'error'; msg.textContent = data.error || 'Something went wrong.';
      }
    } catch (e) {
      msg.className = 'error'; msg.textContent = 'Server error. Try again.';
    }
  };

  window.doLogin = async function() {
    const email = document.getElementById('login-email').value.trim();
    const password = document.getElementById('login-password').value.trim();
    const msg = document.getElementById('login-msg');

    if (!email) { msg.className = 'error'; msg.textContent = 'Please enter email.'; return; }
    if (!password) { msg.className = 'error'; msg.textContent = 'Please enter password.'; return; }

    msg.className = ''; msg.textContent = 'Logging in...';

    try {
      const res = await fetch('https://lara-otp.vercel.app/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (data.success) {
        document.cookie = 'otp_verified=true; max-age=2592000; path=/';
        window.location.href = 'https://laraleatherwholesale.com/';
      } else {
        msg.className = 'error'; msg.textContent = data.error || 'Invalid email or password.';
      }
    } catch(e) {
      msg.className = 'error'; msg.textContent = 'Server error. Try again.';
    }
  };

  window.doForgotPassword = async function(isResend) {
    const email = isResend === true ? resetEmail : document.getElementById('forgot-email').value.trim();
    const msg = document.getElementById(isResend === true ? 'reset-msg' : 'forgot-msg');

    if (!email) { msg.className = 'error'; msg.textContent = 'Please enter your email.'; return; }

    msg.className = ''; msg.textContent = 'Sending code...';

    try {
      const res = await fetch('https://lara-otp.vercel.app/api/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (data.success) {
        resetEmail = email;
        msg.className = 'success'; msg.textContent = 'Code sent! Check your email.';
        if (isResend !== true) {
          document.getElementById('step-forgot').style.display = 'none';
          document.getElementById('step-reset').style.display = 'block';
          document.getElementById('reset-msg').className = '';
          document.getElementById('reset-msg').textContent = '';
        }
      } else {
        msg.className = 'error'; msg.textContent = data.error || 'Something went wrong.';
      }
    } catch(e) {
      msg.className = 'error'; msg.textContent = 'Server error. Try again.';
    }
  };

  window.doResetPassword = async function() {
    const otp = document.getElementById('reset-otp').value.trim();
    const newPassword = document.getElementById('reset-password').value.trim();
    const msg = document.getElementById('reset-msg');

    if (!otp) { msg.className = 'error'; msg.textContent = 'Please enter the code.'; return; }
    if (!newPassword) { msg.className = 'error'; msg.textContent = 'Please enter a new password.'; return; }
    if (newPassword.length < 6) { msg.className = 'error'; msg.textContent = 'Password must be at least 6 characters.'; return; }

    msg.className = ''; msg.textContent = 'Resetting password...';

    try {
      const res = await fetch('https://lara-otp.vercel.app/api/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: resetEmail, otp, newPassword })
      });
      const data = await res.json();
      if (data.success) {
        msg.className = 'success'; msg.textContent = 'Password reset! You can now log in.';
        setTimeout(() => {
          showLogin();
          document.getElementById('login-email').value = resetEmail;
        }, 1500);
      } else {
        msg.className = 'error'; msg.textContent = data.error || 'Something went wrong.';
      }
    } catch(e) {
      msg.className = 'error'; msg.textContent = 'Server error. Try again.';
    }
  };

  async function checkApproval(email) {
    const interval = setInterval(async () => {
      try {
        const res = await fetch('https://lara-otp.vercel.app/api/check?email=' + encodeURIComponent(email));
        const data = await res.json();
        if (data.approved) {
          clearInterval(interval);
          document.cookie = 'otp_verified=true; max-age=2592000; path=/';
          window.location.href = 'https://laraleatherwholesale.com/';
        } else if (data.rejected) {
          clearInterval(interval);
          document.getElementById('otp-box').innerHTML = `
            <div style="text-align:center;padding:40px 20px;">
              <h2 style="color:red;">❌ Application Rejected</h2>
              <p style="color:#666;font-size:14px;">Unfortunately your application has not been approved at this time.<br>Please contact us for more information.</p>
            </div>
          `;
        } else {
          document.getElementById('status-msg').textContent = 'Still waiting for approval...';
        }
      } catch(e) {}
    }, 5000);
  }

  window.togglePass = function(id) {
    const input = document.getElementById(id);
    input.type = input.type === 'password' ? 'text' : 'password';
  };
})();